import "./NewDiscountModalPrimary.css";

import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import { setDiscountModalState } from "../../../stateManagement/actions/claims";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ReactComponent as MagicIcon } from "../../../assets/image/svg/magicIcon.svg";
import { ReactComponent as PercentIcon } from "../../../assets/image/svg/percentageIcon.svg";
import DummyProductPngUrl  from "../../../assets/image/png/dummyProduct.png"
import { truncateToTwoDecimals } from "../../../components/dms_common/DmsUtils";
import RenderSvg from "../../../components/renderSvg/RenderSvg";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

interface DiscountModalProps {
  skuData?: any;
  selectedSkuCode?: string;
  showFooter?: boolean;
  qtyLabel?: string;
  addRemoveQty?: boolean;
  showMrpAndPackSize?: boolean;
  viewAllGrn?: boolean;
  createPrimaryOrder?: boolean;
}

const NewDiscountModalPrimary: React.FC<DiscountModalProps> = ({
  skuData = {},
  selectedSkuCode = "",
  showFooter = true,
  qtyLabel,
  showMrpAndPackSize = false,
  viewAllGrn = false,
  createPrimaryOrder = false
}) => {

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    mrpLabel,
    caseUnitLabelPrimary,
    otherUnitLabelPrimary,
    packUnitLabelPrimary,
    currency,
    createPrimaryOrderUom,
    batchIdConfiguration,
  } = ConfigDictionary;

  const selectedSku = viewAllGrn
    ? 
      (batchIdConfiguration ? 
        skuData?.salesDetails?.find((obj: any) =>
          obj?.batchId === selectedSkuCode && obj?.type?.toLowerCase() !== "freeitem"
        ) ?? {} :
        skuData?.salesDetails?.find(
          (obj: any) =>
            obj?.batchCode === selectedSkuCode && obj?.type?.toLowerCase() !== "freeitem"
        ) ?? {}
      )
    : skuData?.orderDetails?.find(
        (obj: any) =>
          obj?.batchCode === selectedSkuCode && obj?.type?.toLowerCase() !== "freeitem"
      ) ?? {};

  const { discountModalState } = useSelector((state: any) => state.claims);

  const dispatch = useDispatch();

  const handleOnClose = () => {
    dispatch(setDiscountModalState(false));
  };

  function showUomNewDiscountModal(uom: string){
    if (!createPrimaryOrderUom || !createPrimaryOrder) return true
    return (uom === createPrimaryOrderUom)
  }

  return (
    <div>
      <Modal
        open={discountModalState}
        onClose={handleOnClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="right-aligned-modal">
          <div className="invoice-details">
            <div className="product-details">
              <div className="product-details-card">
                <img
                  alt="product-img"
                  src={selectedSku?.extendedAttributes?.blobKey || ConfigDictionary?.defaultCatalogueImage || DummyProductPngUrl}
                  className="product-image"
                  style={{ padding: !selectedSku?.extendedAttributes?.blobKey ? "15px" : "0" }}
                  onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null; 
                    target.src = DummyProductPngUrl; 
                  }}
                />
                <div className="product-info">
                  <h2>{selectedSku?.productInfo?.skuDescription ?? "-"}</h2>
                  <p className="sku_code">{selectedSku?.batchCode ?? "-"}</p>
                  {showMrpAndPackSize && (
                    <p>
                      {mrpLabel}
                      <span style={{ color: "#FF0000" }}>*</span> {currency}{" "}
                      {
                         // Check the conditions for showing different prices
                        (caseUnitLabelPrimary && otherUnitLabelPrimary && packUnitLabelPrimary) ? truncateToTwoDecimals(skuData?.productUI?.mrp) :
                        (caseUnitLabelPrimary && otherUnitLabelPrimary) ? truncateToTwoDecimals(skuData?.productUI?.caseMrp) :
                        (caseUnitLabelPrimary && packUnitLabelPrimary) ? truncateToTwoDecimals(skuData?.productUI?.mrp) :
                        truncateToTwoDecimals(skuData?.productUI?.caseMrp)
                    }
                    </p>
                  )}
                </div>
              </div>

              <div className="close-modal-button" onClick={handleOnClose}>
                <ChevronRightIcon style={{ color: "#fff", width: "30px", height: "30px" }} />
              </div>
            </div>
            <div className="totalQty-csPc" style={{ padding: "0 10px" }}>
              <div className="totalQty-csPc-container" style={{ marginBottom: "10px" }}>
                <span>{qtyLabel ? qtyLabel : "Total Qty"}</span>
                {caseUnitLabelPrimary && showUomNewDiscountModal("caseQty") && (

                <div>
                  <span>
                    {" "}
                    {`${selectedSku?.caseQuantity ?? "0"} ${caseUnitLabelPrimary?.toUpperCase()}`}
                  </span>
                </div>
                )}
                {otherUnitLabelPrimary && showUomNewDiscountModal("otherQty") && (
                  <div>
                    <span>{`${selectedSku?.otherUnitQuantity ?? "0"} ${otherUnitLabelPrimary
                      ?.toUpperCase()
                      ?.slice(0, 3)}`}</span>
                  </div>
                )}
                {packUnitLabelPrimary && showUomNewDiscountModal("pieceQty") && (

                <div>
                  <span>{`${
                    selectedSku?.pieceQuantity ?? "0"
                  } ${packUnitLabelPrimary?.toUpperCase()}`}</span>
                </div>
                )}
              </div>
            </div>
            <div className="discounts-promotions">
              <div className="discountsAndPromoHeading">
                <div className="discountsAndPromoHeadingLabel">
                  <MagicIcon />
                  <p>Discounts & Promotions</p>
                </div>
                <div className=""></div>
              </div>
              {
                ((selectedSku?.discountInfo?.length ?? 0) === 0) ? (
                  <SimpleBar style={{height: "100%", overflow: "auto", marginBottom: "10px", scrollbarWidth: "none"}}>
                  <div className="discounts-list-container" style={{ alignItems: "center", justifyContent: "center" }}>
                    <RenderSvg name={"noPromoAvailableIcon"}/>
                    <span className="no-promotion-available-label">No Promotions Available</span>
                  </div>
                  </SimpleBar>
                ) : 
                <SimpleBar style={{height: "100%", overflow: "auto", marginBottom: "10px", scrollbarWidth: "none"}}>
                <div className="discounts-list-container">
                  {selectedSku?.discountInfo?.map((discount: any) => {
                    if (discount?.id === "focDiscountId") {
                      return <></>;
                    }
                    return (
                      <div className="discount-container">
                        <div className="discount-container-left">
                          <div style={{ display: "flex" }}>
                            <PercentIcon width={17} height={17} />
                          </div>
                          <div className="discount-details">
                            <p>{discount?.discountInfo ?? discount?.promoDescription ?? "-"}</p>
                          </div>
                        </div>

                        <span className="dropDownIcon"></span>
                      </div>
                    );
                  })}
                </div>
                </SimpleBar>
              }
            </div>
            {showFooter ? (
              <div className="total-discount-value">
                <span>Total Discount Value :</span>
                <span>
                  {currency}{" "}
                  {truncateToTwoDecimals((selectedSku?.discountValue ?? 0) + (selectedSku?.couponValue ?? 0))}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default NewDiscountModalPrimary;
